import React, { memo, ReactNode, useCallback, useRef } from 'react';
import { RemoveIcon } from '../../../../components/Icons';
import { ModalRef } from '../../../../components/Modal/Modal';
import { SeparatorLine } from '../../../../components/SeparatorLine/SeparatorLine';
import { RemoveItemModal } from '../RemoveItemModal/RemoveItemModal';

import './CartElement.css';
import { useLanguage } from '../../../../locale/useLanguage';
import { Product } from '../../../../models';
import { extractRange } from '../../../../helpers/dateTimes';
import { CartElement as CartElementModel } from '../../../../models/payment.models';

type CartElementProps = {
  item: CartElementModel;
  price: string;
  originalPrice: string;
  actions?: ReactNode[];
  onDelete: () => void;
};

export const CartElement: React.FC<CartElementProps> = memo(
  ({ item, price, originalPrice, actions, onDelete }) => {
    const modalRef = useRef<ModalRef>(null);
    const [t] = useLanguage();

    const isPdr = item.product === Product.Pdr;
    const elementType = isPdr ? t('cart.pickUpPoint') : t('cart.appointment');

    let title: string;
    let subtitle: string;

    if (isPdr) {
      title = item.configuration.pdr!.name;
    } else {
      const timeRange = extractRange(item.configuration.timeRange);
      title = `${timeRange.from.format('HH:mm')} - ${timeRange.to.format(
        'HH:mm'
      )}`;
    }

    if (isPdr) {
      subtitle = item.configuration.pdr!.indirizzo;
    } else {
      const timeRange = extractRange(item.configuration.timeRange);
      subtitle = timeRange.from.format('DD MMMM YYYY');
    }

    const onDeletePress = useCallback(() => {
      modalRef.current?.openModal();
    }, []);

    return (
      <>
        <div className="cart-element--container">
          <div className="cart-element--top-line">
            <p>{elementType}</p>
            <button
              onClick={onDeletePress}
              className="cart-element--delete-button"
            >
              <RemoveIcon width={18} height={18} />
            </button>
          </div>
          <h3 className="cart-element--title">{title}</h3>
          <p className="cart-element--subtitle">{subtitle}</p>
          <div className="cart-element--bottom-line">
            <div className="cart-element--actions">
              {actions?.map((a, i) => (
                <React.Fragment key={i}>
                  <div className="cart-element--action">{a}</div>
                </React.Fragment>
              ))}
            </div>
            <p className="cart-element--price">€ {price}</p>

            {originalPrice !== price && (
              <small className="cart-element--sale-price">
                € {originalPrice}
              </small>
            )}
          </div>
        </div>
        <RemoveItemModal
          productType={elementType}
          productDescription={title}
          ref={modalRef}
          onRemoveItem={onDelete}
        />
        <SeparatorLine />
      </>
    );
  }
);
